/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendServiceTypesListParams } from './model/apiFrontendServiceTypesListParams';
import type { PaginatedServiceTypeList } from './model/paginatedServiceTypeList';

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiFrontendServiceTypesList = (
  params?: ApiFrontendServiceTypesListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedServiceTypeList>({
    url: `/api/v7/frontend/service-types/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiFrontendServiceTypesListQueryKey = (
  params?: ApiFrontendServiceTypesListParams
) => {
  return [`/api/v7/frontend/service-types/`, ...(params ? [params] : [])] as const;
};

export const getApiFrontendServiceTypesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceTypesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendServiceTypesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendServiceTypesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>> = ({
    signal,
  }) => apiFrontendServiceTypesList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiFrontendServiceTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceTypesList>>
>;
export type ApiFrontendServiceTypesListQueryError = ErrorType<unknown>;

export function useApiFrontendServiceTypesList<
  TData = Awaited<ReturnType<typeof apiFrontendServiceTypesList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiFrontendServiceTypesListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiFrontendServiceTypesList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendServiceTypesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
